export const InventoryFormOperator = Object.freeze({
	IsAnything: 0,
	Is: 1,
	IsNot: 2,
	IsOneOf: 3,
	IsNotOneOf: 4,
	IsBlank: 5,
});
